module.exports = __webpack_public_path__ + "static/media/RHSlidingInDark.ba0b4353.svg";